export default {
  'systems.listView.Status-online': {
    id: 'systems.listView.Status-online',
    defaultMessage: 'Online',
  },
  'systems.listView.Status-offline': {
    id: 'systems.listView.Status-offline',
    defaultMessage: 'Offline',
  },
  'systems.listView.Status-without-alert': {
    id: 'systems.listView.Status-without-alert',
    defaultMessage: 'Working properly',
  },
  'systems.listView.Status-alarm': {
    id: 'systems.listView.Status-alarm',
    defaultMessage: 'Has alarms',
  },
  'systems.listView.Status-notification': {
    id: 'systems.listView.Status-notification',
    defaultMessage: 'Has warnings',
  },
  'systems.listView.Status-update': {
    id: 'systems.listView.Status-update',
    defaultMessage: 'Has firmware update',
  },
};
